
export const calculateReadingTime = (content) => {
    const wordsPerMinute = 200; // Average reading speed
    const words = content.split(/\s+/).filter(Boolean).length; // Count words
    const minutes = Math.ceil(words / wordsPerMinute); // Calculate minutes
    return minutes;
  };
  